import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import RadarTriagem from './RadarTriagem';
import ObrasRadar from '@/pages/painel-pedidos/components/ObrasRadar';

export default function RadarObras() {
  const { password } = useOutletContext<{ password: string }>();
  const [aba, setAba] = useState<'triagem' | 'planilha'>('triagem');

  return (
    <div className="space-y-5">
      <div className="inline-flex items-center bg-gray-100 rounded-full px-1 py-1">
        <button
          onClick={() => setAba('triagem')}
          className={`inline-flex items-center gap-2 text-sm font-semibold rounded-full px-4 py-2 transition-colors cursor-pointer whitespace-nowrap ${
            aba === 'triagem' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <i className="ri-list-check-3"></i>
          Obras para analisar
        </button>
        <button
          onClick={() => setAba('planilha')}
          className={`inline-flex items-center gap-2 text-sm font-semibold rounded-full px-4 py-2 transition-colors cursor-pointer whitespace-nowrap ${
            aba === 'planilha' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <i className="ri-file-upload-line"></i>
          Planilha / Importar
        </button>
      </div>

      {aba === 'triagem' ? <RadarTriagem password={password} /> : <ObrasRadar password={password} />}
    </div>
  );
}